<template>
  <div ref="siteTeamPieChart" :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts';
  import 'echarts-gl';

  export default {
    props: ['data', 'height', 'inProgress', 'myActionRequired', 'completed'],
    data() {
      return {
        style: '',
        myChart: {},
        spaceNumber: null,
      };
    },
    created() {
      this.style = `width:100%; max-height:100%; min-height:${this.height}`;
      this.spaceNumber = (this.inProgress + this.myActionRequired + this.completed) * 0.02;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
    },
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      this.myChart = echarts.init(this.$refs.siteTeamPieChart);
      let option;
      const vm = this;
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
        },
        legend: {
          bottom: 20,
          data: ['My Action Required', 'In Progress', 'Completed'],
        },
        grid: {
          left: 0,
          right: '8%',
          top: 15,
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          data: ['My Access Requests'],
          show: false,
        },
        series: [
          {
            name: 'My Action Required',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
              formatter: function(params) {
                return params['data'] > 0 ? params['data'] : '';
              },
              position: 'inside',
            },
            itemStyle: {
              color: '#FF9495',
            },
            emphasis: {
              focus: 'series',
            },
            data: [this.myActionRequired],
          },
          {
            name: 'empty1',
            type: 'bar',
            stack: 'total',
            itemStyle: {
              color: '#fffbfe',
            },
            tooltip: {
              show: false,
            },
            data: [this.spaceNumber],
          },
          {
            name: 'In Progress',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
              formatter: function(params) {
                return params['data'] > 0 ? params['data'] : '';
              },
              position: 'inside',
            },
            itemStyle: {
              color: '#00B3FF',
            },
            emphasis: {
              focus: 'series',
            },
            data: [this.inProgress],
          },
          {
            name: 'empty2',
            type: 'bar',
            stack: 'total',
            itemStyle: {
              color: '#fffbfe',
            },
            tooltip: {
              show: false,
            },
            data: [this.spaceNumber],
          },
          {
            name: 'Completed',
            type: 'bar',
            stack: 'total',
            label: {
              show: true,
              formatter: function(params) {
                return params['data'] > 0 ? params['data'] : '';
              },
              position: 'inside',
            },
            itemStyle: {
              color: '#7070D6',
            },
            emphasis: {
              focus: 'series',
            },
            data: [this.completed],
          },
        ],
      };

      option && this.myChart.setOption(option);
    },
  };
</script>

<style></style>
